import { Field, WrappedFieldProps } from 'redux-form';
import { MarkdownEditorField, MarkdownEditorProps } from '@mews-commander/ui';
import { FieldProps } from '@optimus-web/core';
import { getError } from '../../utils';

type MarkdownProps = MarkdownEditorProps & FieldProps;
type MarkdownEditorRendererProps = WrappedFieldProps & MarkdownProps;

const MarkDownFieldRenderer = ({ input, meta, ...other }: MarkdownEditorRendererProps) => (
    <MarkdownEditorField error={getError(meta)} {...other} {...input} onChange={(_, value) => input.onChange(value)} />
);

const MarkdownEditorFormField = (props: MarkdownEditorProps) => <Field component={MarkDownFieldRenderer} {...props} />;

export default MarkdownEditorFormField;
